import { render, staticRenderFns } from "./UserGoods.vue?vue&type=template&id=2e0f4796&scoped=true"
import script from "./UserGoods.vue?vue&type=script&lang=js"
export * from "./UserGoods.vue?vue&type=script&lang=js"
import style0 from "./UserGoods.vue?vue&type=style&index=0&id=2e0f4796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0f4796",
  null
  
)

export default component.exports